import {BaseDataProviderAgent} from "./BaseDataProviderAgent";
import {ListOptions} from "../../../services/intf/ListOptions";
import {ListResult} from "../../../model/ListResult";
import {DataProvider} from "../../../services/intf/DataProvider";
import {getResponseBody, handleResponseErrors, sendRequest} from "../../../agent";
import {options, ResponseError} from "superagent";

export class OldBaseDataProvider<TItem, TListOptions extends ListOptions>
    implements DataProvider<TItem, TListOptions> {
    baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    delete = (id: string): Promise<void> =>
        BaseDataProviderAgent.send<TItem>(
            'delete',
            `${this.baseUrl}/remove`, {id: id}).then();

    getByID = (id: string): Promise<TItem> =>
        sendRequest('post', `${this.baseUrl}/getByID`, {id: id})
            .then(getResponseBody)
            .catch((err: ResponseError) => handleResponseErrors(err));

    toListResult = (model: any): ListResult<TItem> => {
        return {
            items: (model.docs ?? []) as TItem[],
            paging: {
                hasPrevPage: model.hasPrevPage,
                hasNextPage: model.hasNextPage,
                limit: model.limit,
                page: model.page,
                totalPages: model.totalPages,
                totalDocs: model.totalDocs,
                prevPage: model.prevPage,
                nextPage: model.nextPage
            }
        }  as ListResult<TItem>;
}

    list = (options: TListOptions): Promise<ListResult<TItem>> =>
        sendRequest('post', `${this.baseUrl}/getList`, options)
            .then(getResponseBody)
            .then(this.toListResult)
            .catch((err: ResponseError) => handleResponseErrors(err));

    getInsertData = (data: TItem): any => data;
    getUpdateData = (id: string, data: TItem): any => data;

    insert = (data: TItem): Promise<TItem> =>
        sendRequest('post', `${this.baseUrl}/create`, this.getInsertData(data))
            .catch((err: ResponseError) => handleResponseErrors(err));

    update = (id: string, data: TItem): Promise<TItem> =>
        sendRequest('post', `${this.baseUrl}/edit`, this.getUpdateData(id, data))
            .then(getResponseBody)
            .catch((err: ResponseError) => handleResponseErrors(err));

    keyProperty: string = "_id";

    applyFilter(options: TListOptions, filter: any): TListOptions {
        return {...options, page: 1, ...filter};
    }
}